module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left",
    staticStyle: {
      "vertical-align": "middle"
    }
  }, [_c('div', {
    staticClass: "inline-block pull-left"
  }, [_c('label', {
    staticClass: "c-pointer btn btn-default",
    attrs: {
      "for": 'file-upload-' + _vm.index + '-' + _vm.type
    }
  }, [(_vm.image) ? _c('div', {
    staticClass: "inline-block",
    staticStyle: {
      "line-height": "50px"
    }
  }, [(_vm.image) ? _c('img', {
    staticClass: "h-auto img-responsive inline-block",
    attrs: {
      "src": _vm.image,
      "id": 'img-load' + _vm.index + '-' + _vm.type
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.image && _vm.type === 1) ? _c('i', {
    staticClass: "fa fa-picture-o inline-block",
    staticStyle: {
      "font-size": "50px"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.image && _vm.type === 2) ? _c('i', {
    staticClass: "fa fa-picture-o inline-block",
    staticStyle: {
      "font-size": "98px"
    }
  }) : _vm._e()]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": 'file-upload-' + _vm.index + '-' + _vm.type,
      "type": "file"
    },
    on: {
      "change": _vm.onFileChange
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": 'myModal-' + _vm.index + '-' + _vm.type,
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(0), _vm._v(" "), (_vm.type === 1) ? _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("小圖")]) : _vm._e(), _vm._v(" "), (_vm.type === 2) ? _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("小圖")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.image
    }
  })]), _vm._v(" "), _vm._m(1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Close")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("返回")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ab97fd10"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Menu/Temp/ImgUpdateTemp.vue
// module id = 2536
// module chunks = 1